// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"008eeba3","36":"12650d91","200":"907e54b4","536":"b2e92abe","592":"7f72a991","632":"dc2b34af","712":"02e9584c"}[chunkId] + ".chunk.js";
};